import { AxiosResponse } from "axios";
import { createSliceSaga } from "../saga-helper";
import { call, put, select } from "redux-saga/effects";
import { CampaignsReducerAction } from "./slice";

import {
  AdsAccountsService,
  // CampaignsByAdAccountService,
  CampaignsService,
  GetAdsCopiesByCampaignId,
  InsightsService,
} from "../../services/CampaignsService";
import { campaignsSelector, insightsSelector } from "./selector";
import { CampaignsListType } from "./types";

let currentCampaignsController: AbortController | null = null;

const saga = createSliceSaga({
  name: "campgains-saga-state",
  caseSagas: {
    *getCampaigns(action: {
      payload: {
        source?: string[];
        start_date?: Date;
        end_date?: Date;
        skip: number;
        limit: number;
        search: string;
        status: string;
        form_id?: number;
        ad_account_id: null | string;
      };
      type: string;
    }) {
      // Cancel any ongoing request
      if (currentCampaignsController) {
        currentCampaignsController.abort();
      }

      // Create a new controller for this request
      currentCampaignsController = new AbortController();

      try {
        const campaignsList: CampaignsListType = yield select(
          campaignsSelector
        );
        yield put(CampaignsReducerAction.setIsLoading(true));
        // Step-2: Calling the Service file API and setting the data in reducer
        const { data: apiResponse, status }: AxiosResponse = yield call(
          CampaignsService,
          action.payload,
          currentCampaignsController.signal
        );

        if (status === 200) {
          let responseData = apiResponse.data;
          if (campaignsList.data.length > 0 && responseData.length > 0)
            responseData = [...campaignsList.data, ...responseData];

          yield put(
            CampaignsReducerAction.setCampaigns({
              total: apiResponse.total ?? 0,
              data: responseData,
            })
          );
        }
      } catch (error: any) {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Campaign API call canceled");
        } else {
          console.error("Error fetching Campaigns!", error);
        }
      } finally {
        yield put(CampaignsReducerAction.setIsLoading(false));
      }
    },
    *getInsights(action: {
      payload: {
        source?: string[];
        start_date?: Date;
        end_date?: Date;
        page: number;
        limit: number;
        search: string;
        group_by: string;
        form_id?: number;
        ad_account_id: null | string;
        sort_column?: string;
        sort_direction?: string;
      };
      type: string;
    }) {
      // Cancel any ongoing request
      if (currentCampaignsController) {
        currentCampaignsController.abort();
      }

      // Create a new controller for this request
      currentCampaignsController = new AbortController();

      try {
        const insightsList: CampaignsListType = yield select(insightsSelector);
        yield put(CampaignsReducerAction.setIsLoading(true));
        // Step-2: Calling the Service file API and setting the data in reducer
        const { data: apiResponse, status }: AxiosResponse = yield call(
          InsightsService,
          action.payload,
          currentCampaignsController.signal
        );

        if (status === 200) {
          let responseData = apiResponse.data;
          if (insightsList.data.length > 0 && responseData.length > 0)
            responseData = [...insightsList.data, ...responseData];

          yield put(
            CampaignsReducerAction.setInsights({
              last_page: apiResponse?.last_page || 0,
              per_page: apiResponse?.per_page || 0,
              current_page: apiResponse?.current_page || 0,
              total: apiResponse?.total || 0,
              data: responseData,
            })
          );
        }
      } catch (error: any) {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("getInsights API call canceled");
        } else {
          console.error("Error fetching Campaigns!", error);
        }
      } finally {
        yield put(CampaignsReducerAction.setIsLoading(false));
      }
    },
    *getAdsAccountsSaga() {
      try {
        yield put(CampaignsReducerAction.setAdsIsLoading(true));

        const response: AxiosResponse = yield call(AdsAccountsService);

        if (response.status === 200) {
          yield put(
            CampaignsReducerAction.setAdsAccounts(response?.data?.data)
          );
        } else {
          console.error("Unexpected status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching Ads Accounts:", error);
      } finally {
        yield put(CampaignsReducerAction.setAdsIsLoading(false));
      }
    },
    *GetAdsCopiesByCampaignIdSaga(action: {
      payload: {
        campaign_id: string;
      };
      type: string;
    }) {
      try {
        yield put(CampaignsReducerAction.setAdsIsLoading(true));

        const response: AxiosResponse = yield call(
          GetAdsCopiesByCampaignId,
          action.payload
        );

        if (response.status === 200) {
          yield put(
            CampaignsReducerAction.setCampaingsAdCopies(response?.data?.data)
          );
        } else {
          console.error("Unexpected status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching Ads Accounts:", error);
      } finally {
        yield put(CampaignsReducerAction.setAdsIsLoading(false));
      }
    },

    // *getCampaignsByAdAccountSaga(action: { payload: string | number }) {
    //   try {
    //     yield put(CampaignsReducerAction.setCampaignsIsLoading(true));

    //     const response: AxiosResponse = yield call(
    //       CampaignsByAdAccountService,
    //       action.payload
    //     );

    //     if (response.status === 200) {
    //       yield put(CampaignsReducerAction.setCampaignsData(response?.data?.data));
    //     } else {
    //       console.error("Unexpected status:", response.status);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching Campaigns:", error);
    //   } finally {
    //     yield put(CampaignsReducerAction.setCampaignsIsLoading(false));
    //   }
    // },
  },
  sagaType: "takeEvery",
});

export const {
  actions: CampaignsSagaAction,
  saga: CampaignsSaga,
  name: CampaignsSagaName,
} = saga;
